import React, { useContext } from "react";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import * as links from "../../../../utils/links";
import axios from "axios";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";

const DeleteCliente = ({ isOpen, onClose, clienteId }) => {
  const navigate = useNavigate();

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const token = authInfo?.dataUser?.token;

  const deleteHandler = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_SERVIDOR}/cliente/${clienteId}`,
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };

    axios
      .request(config)
      .then((res) => {
        setNotiMessage({
          type: "success",
          message: "Cliente excluído com sucesso.",
        });
        onClose();
        navigate(links.DASHBOARD_CLIENTES);
      })
      .catch((err) => {
        if ([401, 403].includes(err.response?.status)) {
          setNotiMessage({
            type: "error",
            message: "A sua sessão expirou, para continuar faça login novamente.",
          });
          setDataUser(null);
        } else {
          // Convertendo para string caso seja um objeto
          const errorMessage = typeof err?.response?.data === 'object' ? 
            JSON.stringify(err?.response?.data) : 
            (err?.response?.data || "Erro ao excluir cliente");
            
          setNotiMessage({
            type: "error",
            message: errorMessage,
          });
        }
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent backgroundColor="#1a202c">
        <ModalCloseButton color="white" />
        <ModalBody style={{ marginTop: "50px", textAlign: "center" }}>
          <Text fontSize="20px" color="white">
            Deseja excluir este cliente?
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose} color="white">
            Cancelar
          </Button>
          <Button
            colorScheme="red"
            mr={3}
            onClick={deleteHandler}
            style={{ marginLeft: "20px" }}
          >
            Excluir
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteCliente;
